export default {
    common: {
        ok: 'ОК',
        cancel: 'Скасувати',
        save: 'Зберегти',
        delete: 'Видалити',
        edit: 'Редагувати',
        close: 'Закрити',
        confirm: 'Підтвердити',
        back: 'Назад',
        next: 'Далі',
        apply: 'Застосувати',
        done: 'Готово',
        loading: 'Завантаження...',
        error: 'Помилка',
        success: 'Успіх',
        warning: 'Попередження',
        info: 'Інформація'
    },
    navbar: {
        home: 'Головна',
        history: 'Історія',
        settings: 'Налаштування',
        profile: 'Профіль',
        vacation: 'Відпустка',
        scanner: {
            checkIn: 'Вхід',
            bleCheckIn: 'BLE-вхід',
            checkingLocation: 'Перевірка місцезнаходження...',
            locationRequired: 'Потрібне місцезнаходження'
        }
    },
    settings: {
        title: 'Налаштування',
        notifications: {
            title: 'Сповіщення',
            checkInReminders: 'Нагадування про вхід',
            checkInRemindersDesc: 'Нагадувати про вхід до початку роботи',
            checkOutReminders: 'Нагадування про вихід',
            checkOutRemindersDesc: 'Нагадувати про вихід після завершення роботи',
            reminderTime: 'Час нагадування',
            reminderTimeDesc: 'За скільки заздалегідь надсилати нагадування',
            updated: {
                checkIn: 'Нагадування про вхід оновлено',
                checkOut: 'Нагадування про вихід оновлено',
                time: 'Час нагадування оновлено'
            }
        },
        bleAttendance: {
            title: 'Bluetooth відвідуваність',
            enableLabel: 'Увімкнути BLE відвідуваність',
            enableDesc: 'Автоматичне виявлення Bluetooth-пристрою для реєстрації відвідуваності',
            enabled: 'Bluetooth відвідуваність увімкнено',
            disabled: 'Bluetooth відвідуваність вимкнено',
            permissionDenied: 'Дозволи Bluetooth відхилено. Увімкніть у налаштуваннях пристрою.',
            updateFailed: 'Не вдалося оновити налаштування Bluetooth'
        },
        reminder: {
            minutesBefore: 'Хвилин до',
            minutesAfter: 'Хвилин після',
            minutes: {
                one: '1 хвилина',
                other: '{count} хвилин'
            }
        },
        appearance: {
            title: 'Вигляд',
            theme: 'Тема',
            themeDesc: 'Виберіть бажану колірну тему',
            themeOptions: {
                light: 'Світла',
                dark: 'Темна',
                auto: 'Авто (Система)'
            },
            themeChanged: 'Тему змінено на {theme}'
        },
        language: {
            title: 'Мова',
            language: 'Мова',
            languageDesc: 'Виберіть бажану мову',
            languageChanged: 'Мову змінено на {language}'
        },
        profile: {
            title: 'Профіль',
            workerId: 'ID працівника',
            name: "Ім'я",
            lastSync: 'Остання синхронізація',
            notAssigned: 'Не призначено',
            unknown: 'Невідомо',
            never: 'Ніколи'
        },
        reminderTimeOptions: {
            minutes5: '5 хвилин',
            minutes10: '10 хвилин',
            minutes15: '15 хвилин',
            minutes30: '30 хвилин',
            hour1: '1 година'
        }
    },
    dashboard: {
        title: 'Панель',
        checkIn: 'Вхід',
        checkOut: 'Вихід',
        welcome: 'Ласкаво просимо',
        currentStatus: 'Поточний статус',
        todayAttendance: 'Відвідуваність сьогодні',
        totalDays: 'Всього днів',
        comingSoon: 'Незабаром',
        duration: 'Тривалість',
        shortDuration: 'Порушення',
        onTrack: 'В нормі',
        working: 'Робочий час',
        durationComplete: 'Виконано',
        notCheckedIn: 'Не відмічено',
        notYet: 'Ще ні',
        completed: 'Завершено',
        onTime: 'Вчасно',
        late: 'Запізнення',
        early: 'Раніше',
        missingCheckOut: 'Немає відмітки виходу',
        manualEntry: 'Ручне введення',
        vacationUsed: 'Використано',
        vacationLeft: 'Залишилось',
        attendanceRegistered: 'Відмітку зареєстровано',
        qrValidated: 'QR-код підтверджено',
        bleValidated: 'Bluetooth підтверджено',
        processingBleCheckin: 'Обробка входу через Bluetooth...',
        logout: {
            confirm: 'Підтвердьте вихід',
            message:
                'Ви впевнені, що хочете вийти? Потрібно буде заново призначити профіль працівника.',
            cancel: 'Скасувати',
            button: 'Вийти'
        }
    },
    history: {
        title: 'Історія',
        noRecords: 'Записів відвідуваності не знайдено',
        checkInTime: 'Вхід',
        checkOutTime: 'Вихід',
        labels: {
            duration: 'Тривалість',
            location: 'Місцезнаходження',
            qrCode: 'QR-код',
            geofence: 'Геозона'
        },
        viewToggle: {
            calendar: 'Календар',
            list: 'Список'
        },
        loading: 'Завантаження історії відвідуваності...',
        error: 'Не вдалося завантажити історію. Спробуйте ще раз.',
        retry: 'Повторити',
        emptyState: 'Немає записів за цей період.',
        validated: 'Підтверджено',
        notValidated: 'Не підтверджено',
        calendar: {
            prevMonth: 'Попередній місяць',
            nextMonth: 'Наступний місяць',
            viewDetailsAtTime: 'Переглянути деталі для {time}'
        },
        status: {
            holiday: 'Свято',
            absence: 'Відсутність'
        }
    },
    scanner: {
        title: 'QR-сканер',
        scanning: 'Сканування...',
        scanSuccess: 'Сканування успішне',
        scanError: 'Помилка сканування'
    },
    profile: {
        title: 'Профіль',
        assignWorker: 'Призначити працівника'
    },
    admin: {
        title: 'Адмін-панель',
        accessDenied: 'Доступ заборонено',
        subtitle: 'Адміністративний доступ — використовуйте з обережністю',
        banner: {
            title: 'АКТИВНИЙ РЕЖИМ АДМІНІСТРАТОРА',
            description: 'Увімкнено налаштування налагодження та адміністративні функції. Використовуйте з обережністю.'
        },
        debug: {
            banner: {
                title: 'ЛИШЕ ДЛЯ ТЕСТУВАННЯ',
                desc: 'Режими налагодження оминають перевірки безпеки. Вимкніть перед продакшеном.'
            },
            bypass: {
                title: 'Оминути перевірку геозони',
                desc: 'Дозволити вхід/вихід з будь-якого місця'
            },
            staticQr: {
                title: 'Дозволити статичний QR-код',
                desc: 'Приймати заздалегідь визначений тестовий QR-код (ніколи не спливає)'
            },
            lastModified: 'Остання зміна:',
            time: {
                never: 'Ніколи',
                justNow: 'Щойно',
                minutes: {
                    one: '1 хвилину тому',
                    other: '{count} хвилин тому'
                },
                hours: {
                    one: '1 годину тому',
                    other: '{count} годин тому'
                }
            }
        },
        prompt: {
            title: 'Автентифікація адміністратора',
            description: 'Введіть пароль адміністратора, щоб продовжити',
            passwordLabel: 'Пароль',
            passwordPlaceholder: 'Введіть пароль адміністратора',
            unlock: 'Розблокувати панель',
            accessGranted: 'Надано доступ адміністратора',
            incorrectPassword: 'Неправильний пароль',
            authFailed: 'Помилка автентифікації',
            lockedTitle: 'Обліковий запис заблоковано',
            attemptsRemaining: 'Залишилося спроб: {count}',
            errors: {
                required: 'Потрібен пароль',
                lockedOut: 'Занадто багато невдалих спроб. Спробуйте за {minutes} хв.'
            }
        },
        alerts: {
            exit: {
                header: 'Вийти з режиму адміністратора',
                message:
                    'Ви впевнені, що хочете вийти з режиму адміністратора? Щоб увійти знову, потрібен буде жест.',
                confirm: 'Вийти'
            },
            forget: {
                header: 'Забути працівника',
                message:
                    'Ви впевнені, що хочете забути цього працівника? Це очистить усі локальні дані та поверне застосунок у початковий стан. Дію не можна скасувати.',
                confirm: 'Забути працівника'
            },
            resetBundle: {
                header: 'Скинути пакет застосунку',
                message: 'Застосунок буде скинуто до вбудованої версії. Застосунок закриється і його потрібно буде відкрити вручну.',
                confirm: 'Скинути і закрити'
            }
        },
        cards: {
            manualRecords: {
                title: 'Ручні записи',
                value: 'Керування відвідуваністю',
                status: 'Створення, редагування та видалення записів',
                open: 'Відкрити записи'
            },
            logs: {
                title: 'Системні журнали',
                value: 'Активність і безпека',
                status: 'Журнали активності та моніторинг безпеки',
                open: 'Відкрити журнали'
            },
            worker: {
                title: 'Поточний працівник',
                noWorker: 'Працівника не призначено',
                id: 'ID',
                assignToContinue: 'Призначте працівника, щоб продовжити',
                forget: 'Забути працівника',
                workerIdMissing: 'ID працівника не знайдено',
                forgotten: 'Працівника забуто. Усі локальні дані очищено.'
            },
            settings: {
                title: 'Налаштування',
                value: 'Конфігурація',
                status: 'Налаштування застосунку та параметри налагодження',
                open: 'Відкрити налаштування'
            },
            system: {
                title: 'Система',
                value: 'Оновити',
                status: 'Дані та стан системи',
                refreshButton: 'Оновити дані',
                refreshing: 'Оновлення всіх даних...',
                refreshed: 'Усі дані успішно оновлено!',
            refreshFailed: 'Не вдалося оновити дані',
            checkSyncStatus: 'Перевірити статус синхронізації',
            forceMarkPending: 'Примусово позначити як очікує',
            toasts: {
                syncStatus: 'Сьогодні: {today} (очікує: {pendingToday})\nУсього очікує: {totalPending}',
                syncStatusFailed: 'Не вдалося перевірити статус синхронізації',
                noRecordsToday: 'На сьогодні записів не знайдено',
                markedPending: 'Позначено {count} запис(и) як такі, що очікують. Використайте «Оновити дані» для синхронізації.',
                markPendingFailed: 'Не вдалося позначити записи як такі, що очікують'
            }
            },
            schedule: {
                title: 'Графік роботи',
                type: 'Тип',
                duration: 'Тривалість',
                checkIn: 'Вхід',
                checkOut: 'Вихід',
                before: 'до',
                after: 'після',
                maxOffsetStart: 'Макс. зсув початку',
                minOffsetEnd: 'Мін. зсув кінця',
                days: 'Дні'
            },
            notifications: {
                title: 'Сповіщення',
                value: 'Тест',
                status: 'Надіслати тестове сповіщення',
                send: 'Надіслати тест',
                sent: 'Тестове сповіщення надіслано! Перевірте панель сповіщень.',
                sendFailed: 'Не вдалося надіслати тестове сповіщення'
            },
            session: {
                started: 'Сесію адміністратора розпочато'
            }
        },
        geofence: {
            title: 'Перегляд геозони',
            status: {
                inside: 'Всередині геозони',
                outside: 'Поза геозоною',
                unknown: 'Невідомо'
            },
            accuracy: {
                label: 'Точність GPS',
                meters: 'метрів',
                na: 'немає'
            },
            error: 'Помилка:',
            legend: {
                title: 'Легенда',
                boundary: 'Межа геозони',
                currentLocation: 'Поточне місцезнаходження'
            }
        },
        totp: {
            title: 'Налаштування секрету TOTP',
            subtitle: 'Налаштуйте спільний секрет для перевірки QR-коду',
            status: {
                status: 'Статус:',
                configured: 'Налаштовано',
                notConfigured: 'Не налаштовано',
                lastSynced: 'Остання синхронізація:',
                secretLength: 'Довжина секрету:',
                characters: '{chars} символів'
            },
            info: {
                howTo: 'Як налаштувати:',
                scanTitle: 'Скануйте QR-код:',
                scanDesc: 'Використайте сканер нижче, щоб сканувати з застосунку Generator',
                manualTitle: 'Ручне введення:',
                manualDesc: 'Введіть секрет Base32 безпосередньо',
                note: 'Обидва застосунки повинні використовувати однаковий секрет для коректної перевірки.'
            },
            scan: {
                title: 'Сканувати QR-код із Generator',
                desc: 'Скануйте будь-який QR-код із застосунку Generator, щоб автоматично отримати та зберегти секрет.',
                open: 'Відкрити сканер QR',
                modalTitle: 'Сканувати QR-код',
                instructions: 'Розташуйте QR-код із застосунку Generator у рамці'
            },
            manual: {
                title: 'Ручне введення секрету',
                placeholder: 'Введіть секрет Base32 (наприклад, JBSWY3DPEHPK3PXP)'
            },
            validation: {
                invalidFormat: 'Неправильний формат. Використовуйте лише символи A-Z та 2-7.',
                tooShort: 'Секрет надто короткий. Рекомендовано мінімум 16 символів.',
                valid: 'Коректний формат Base32'
            },
            actions: {
                save: 'Зберегти секрет',
                update: 'Оновити секрет',
                clear: 'Очистити секрет'
            },
            viewCurrent: 'Переглянути поточний секрет',
            modal: {
                currentTitle: 'Поточний секрет TOTP',
                keepSecure: 'Зберігайте цей секрет у безпеці! Маючи його, можна генерувати дійсні токени.',
                copy: 'Копіювати в буфер'
            },
            test: {
                title: 'Тест генерації TOTP',
                desc: 'Згенеруйте токен, щоб перевірити, що секрет працює коректно. Токен має збігатися з показаним у застосунку Generator.',
                generate: 'Згенерувати тестовий токен',
                currentToken: 'Поточний токен:',
                validFor: 'Дійсний {seconds}с'
            },
            alert: {
                clear: {
                    header: 'Очистити секрет TOTP?',
                    message: 'Це видалить збережений секрет. Щоб налаштувати його знову, відскануйте QR-код або введіть вручну.',
                    confirm: 'Очистити'
                }
            },
            toast: {
                saved: 'Секрет TOTP успішно збережено',
                saveFailed: 'Не вдалося зберегти секрет',
                cleared: 'Секрет TOTP очищено',
                clearFailed: 'Не вдалося очистити секрет',
                loadFailed: 'Не вдалося завантажити секрет',
                copySuccess: 'Секрет скопійовано до буфера',
                copyFailed: 'Не вдалося скопіювати секрет',
                openScannerFailed: 'Не вдалося відкрити сканер',
                generateFailed: 'Не вдалося згенерувати токен',
                noSecret: 'Секрет не налаштовано',
                scanSaved: 'Секрет відскановано та збережено ({length} символів)',
                invalidQR: 'Недійсний формат QR-коду',
                scanFailed: 'Сканування не вдалося: {error}'
            }
        },
        manualRecords: {
            pageTitle: 'Керування ручними записами',
            labels: {
                worker: 'Працівник',
                month: 'Місяць'
            },
            actions: {
                create: 'Створити ручний запис'
            },
            loading: 'Завантаження записів...',
            empty: 'За цей місяць немає записів відвідуваності.',
            status: {
                inProgress: 'В процесі',
                checkedIn: 'Вхід',
                checkedOut: 'Вихід',
                incomplete: 'Не завершено'
            },
            edit: {
                title: 'Редагувати запис відвідуваності',
                info: 'Відредагуйте час входу та виходу. Статус буде обчислено автоматично за графіком.',
                update: 'Оновити запис'
            },
            create: {
                title: 'Створити ручний запис',
                create: 'Створити запис'
            },
            fields: {
                date: 'Дата',
                checkIn: 'Час входу',
                checkOut: 'Час виходу',
                checkOutOptional: 'Час виходу (необовʼязково)',
                status: 'Статус'
            },
            delete: {
                header: 'Видалити запис',
                message: 'Ви впевнені, що хочете видалити цей запис відвідуваності? Дію не можна скасувати.'
            },
            toasts: {
                loaded: 'Завантажено записів: {count}',
                loadFailed: 'Не вдалося завантажити записи',
                updated: 'Запис успішно оновлено',
                updateFailed: 'Не вдалося оновити запис',
                created: 'Ручний запис створено',
                createFailed: 'Не вдалося створити запис',
                deleted: 'Запис видалено',
                deleteFailed: 'Не вдалося видалити запис'
            }
        }
    },
    manualRecords: {
        pageTitle: 'Керування ручними записами',
        labels: {
            worker: 'Працівник',
            month: 'Місяць'
        },
        actions: {
            create: 'Створити ручний запис'
        },
        loading: 'Завантаження записів...',
        empty: 'За цей місяць немає записів відвідуваності.',
        status: {
            inProgress: 'В процесі',
            checkedIn: 'Вхід',
            checkedOut: 'Вихід',
            incomplete: 'Не завершено'
        },
        edit: {
            title: 'Редагувати запис відвідуваності',
            info: 'Відредагуйте час входу та виходу. Статус буде обчислено автоматично за графіком.',
            update: 'Оновити запис'
        },
        create: {
            title: 'Створити ручний запис',
            create: 'Створити запис'
        },
        fields: {
            date: 'Дата',
            checkIn: 'Час входу',
            checkOut: 'Час виходу',
            checkOutOptional: 'Час виходу (необовʼязково)',
            status: 'Статус'
        },
        delete: {
            header: 'Видалити запис',
            message: 'Ви впевнені, що хочете видалити цей запис відвідуваності? Дію не можна скасувати.'
        },
        toasts: {
            loaded: 'Завантажено записів: {count}',
            loadFailed: 'Не вдалося завантажити записи',
            updated: 'Запис успішно оновлено',
            updateFailed: 'Не вдалося оновити запис',
            created: 'Ручний запис створено',
            createFailed: 'Не вдалося створити запис',
            deleted: 'Запис видалено',
            deleteFailed: 'Не вдалося видалити запис'
        }
    },
    components: {
        attendanceCard: {
            inProgress: 'В процесі'
        },
        geofenceCard: {
            location: 'Місцезнаходження',
            atOffice: 'В офісі',
            outside: 'Поза офісом',
            verifying: 'Перевірка...',
            checking: 'Перевірка місцезнаходження...',
            youAreInside: 'На місці',
            needToBeInside: 'Потрібно бути в офісі для входу/виходу'
        },
        qrFeedback: {
            titles: {
                validated: 'QR-код підтверджено',
                locationFailed: 'Перевірка місцезнаходження не вдалася',
                validationFailed: 'Перевірка не вдалася'
            },
            messages: {
                success: 'QR-код успішно підтверджено!',
                locationErrorDefault:
                    'Перевірка місцезнаходження не вдалася. Залишайтеся в межах офісу.',
                failedDefault: 'Перевірка QR-коду не вдалася. Спробуйте ще раз.'
            },
            actions: {
                tryAgain: 'Спробувати ще раз',
                cancel: 'Скасувати'
            }
        }
    },
    notifications: {
        checkIn: {
            before: {
                title: 'Час відмітити вхід',
                body: 'Не забудьте відмітити вхід по прибуттю до офісу'
            },
            after: {
                title: 'Немає відмітки входу',
                body: 'Відмітка входу відсутня. Зробіть це якнайшвидше'
            }
        },
        checkOut: {
            before: {
                title: 'Час відмітити вихід',
                body: 'Не забудьте відмітити вихід перед виходом з офісу'
            },
            after: {
                title: 'Немає відмітки виходу',
                body: 'Відмітка виходу відсутня. Зробіть це зараз'
            }
        },
        test: {
            title: 'Тестове сповіщення',
            body: 'Це тестове сповіщення з адмін-панелі Warden'
        },
        settings: {
            checkInBeforeLabel: 'Нагадування про вхід (до)',
            checkInBeforeDesc: 'Нагадувати до початку роботи',
            checkInAfterLabel: 'Нагадування про вхід (після)',
            checkInAfterDesc: 'Нагадувати, якщо я забув відмітитися',
            checkOutBeforeLabel: 'Нагадування про вихід (до)',
            checkOutBeforeDesc: 'Нагадувати до завершення роботи',
            checkOutAfterLabel: 'Нагадування про вихід (після)',
            checkOutAfterDesc: 'Нагадувати, якщо я забув відмітитися'
        }
    },
    scannerView: {
        ui: {
            initializing: 'Ініціалізація сканера...',
            notSupportedTitle: 'Сканер не підтримується',
            notSupportedMessage: 'Сканування QR недоступне на цьому пристрої.',
            verifyingLocation: 'Перевірка місцезнаходження...',
            locationRequired: 'Потрібне місцезнаходження',
            startStartingTitle: 'Запуск сканера...',
            preparingCamera: 'Підготовка камери до розпізнавання QR-кодів',
            startScanButton: 'Почати сканування',
            verifyLocationButton: 'Перевірити місцезнаходження',
            cancel: 'Скасувати',
            toggleFlashAria: 'Перемкнути ліхтарик',
            debugPrefix: 'Налагодження: locationStatus = "{status}"'
        },
        alerts: {
            scannerErrorTitle: 'Помилка сканера',
            ok: 'ОК',
            locationRequiredTitle: 'Потрібне місцезнаходження',
            locationRequiredMessage:
                'Потрібно бути в межах офісу, щоб сканувати QR-коди.'
        },
        toasts: {
            notSupported: 'Сканування QR не підтримується на цьому пристрої',
            genericError: 'Помилка сканера. Спробуйте ще раз.'
        },
        errors: {
            timeout:
                'Час очікування місцезнаходження вичерпано. Переконайтеся, що GPS увімкнено, і спробуйте ще раз.',
            failedOpenCamera: 'Не вдалося відкрити сканер камери',
            failedScan: 'Не вдалося сканувати QR-код'
        },
        location: {
            insideReady: 'Місцезнаходження підтверджено. Готово до сканування.',
            outsideBoundary: 'Потрібно бути в межах офісу, щоб сканувати QR-коди.',
            poorAccuracy: 'Низька точність GPS. Перейдіть у відкрите місце.',
            gpsUnavailable: 'Потрібен сигнал GPS. Перейдіть у відкрите місце.',
            permissionRequired: 'Потрібен дозвіл на місцезнаходження.',
            checking: 'Перевірка місцезнаходження...',
            verificationRequired: 'Потрібна перевірка місцезнаходження.'
        },
        headerTitle: 'QR-сканер'
    },
    logViewer: {
        title: 'Журнали',
        search: 'Пошук журналів...',
        filters: {
            title: 'Фільтри',
            active: 'Активні',
            category: 'Категорія',
            level: 'Рівень',
            type: 'Тип',
            dateRange: 'Діапазон дат',
            startDate: 'Початкова дата',
            endDate: 'Кінцева дата',
            clearFilters: 'Очистити фільтри'
        },
        categories: {
            all: 'Всі категорії',
            sync: 'Синхронізація',
            auth: 'Авторизація',
            location: 'Місцеположення',
            qr: 'QR',
            ble: 'BLE',
            api: 'API',
            admin: 'Адміністратор',
            system: 'Система',
            security: 'Безпека'
        },
        levels: {
            all: 'Всі рівні',
            debug: 'Налагодження',
            info: 'Інформація',
            warn: 'Попередження',
            error: 'Помилка'
        },
        securityTypes: {
            all: 'Всі типи',
            invalid_qr: 'Невірний QR',
            expired_qr: 'Прострочений QR',
            replay_attempt: 'Повторна атака',
            geofence_failure: 'Помилка геозони',
            repeated_failure: 'Повторювані помилки'
        },
        actions: {
            export: 'Експорт',
            clear: 'Очистити журнали',
            refresh: 'Оновити',
            viewDetails: 'Показати деталі',
            hideDetails: 'Сховати деталі'
        },
        states: {
            loading: 'Завантаження журналів...',
            empty: 'Журнали не знайдені',
            emptyFiltered: 'Немає журналів, що відповідають фільтрам',
            emptyActivity: 'Немає журналів активності',
            emptySecurity: 'Підозріла активність не виявлена'
        },
        details: {
            title: 'Деталі журналу',
            timestamp: 'Часова мітка',
            level: 'Рівень',
            category: 'Категорія',
            message: 'Повідомлення',
            context: 'Додаткові деталі',
            workerId: 'ID працівника',
            location: 'Місцеположення',
            failureReason: 'Причина помилки',
            attemptCount: 'Спроби',
            syncStatus: 'Статус синхронізації',
            isPermanent: 'Постійний запис'
        },
        badges: {
            suspicious: 'ПІДОЗРІЛИЙ',
            permanent: 'ПОСТІЙНИЙ'
        },
        count: {
            total: '{count} журналів',
            suspicious: '{count} підозрілих'
        },
        alerts: {
            clearTitle: 'Очистити всі журнали',
            clearMessage: 'Ви впевнені, що хочете видалити всі журнали? Цю дію неможливо скасувати.',
            clearConfirm: 'Очистити журнали',
            clearSecurityTitle: 'Очистити журнали безпеки',
            clearSecurityMessage: 'Ви впевнені, що хочете видалити всі журнали безпеки? Цю дію неможливо скасувати.'
        },
        toasts: {
            exported: 'Журнали успішно експортовані',
            exportFailed: 'Не вдалося експортувати журнали',
            cleared: 'Всі журнали були очищені',
            clearFailed: 'Не вдалося очистити журнали',
            refreshed: 'Журнали оновлені',
            refreshFailed: 'Не вдалося оновити журнали'
        }
    },
    profileAssignment: {
        noUser: {
            title: 'Користувача не встановлено',
            message: 'Будь ласка, зверніться до адміністратора для налаштування пристрою.',
            adminAccess: 'Доступ адміністратора'
        },
        auth: {
            authenticating: 'Аутентифікація...'
        },
        workerSelection: {
            title: 'Призначити працівника пристрою',
            subtitle: 'Виберіть працівника, який використовуватиме цей пристрій',
            loading: 'Завантаження працівників...',
            searchPlaceholder: 'Пошук працівників за іменем або ID...',
            workersFound: 'Знайдено {count} працівник(ів)',
            selectedWorker: 'Обраний працівник:',
            workerId: 'ID: {id}',
            noResults: 'Не знайдено працівників, що відповідають "{query}"',
            assignButton: 'Призначити працівника пристрою',
            selectWorker: 'Будь ласка, оберіть працівника'
        },
        errors: {
            connectionError: 'Неможливо підключитися до сервера. Перевірте з\'єднання.',
            loadWorkersFailed: 'Не вдалося завантажити працівників. Спробуйте ще раз.',
            invalidPassword: 'Невірний пароль адміністратора. Спробуйте ще раз.',
            authFailed: 'Аутентифікація не вдалася. Спробуйте ще раз.',
            workerNotFound: 'Працівника не знайдено. Зверніться до IT-підтримки.',
            assignmentFailed: 'Не вдалося аутентифікувати працівника. Спробуйте ще раз.'
        }
    },
    vacation: {
        title: 'Відпустка',
        summary: 'Інформація про відпустку',
        paidRemaining: 'Доступно зараз',
        perYear: 'Нараховується на рік',
        atYearStart: 'На 1 січня',
        unpaidUsed: 'За власний рахунок',
        history: 'Деталі',
        from: 'З',
        to: 'по',
        adjustment: 'Коригування',
        noHistory: 'Записів не знайдено',
        types: {
            VACATION: 'Відпустка',
            WORKING_HOLIDAY: 'Відгул',
            ADJUSTMENT: 'Коригування',
        },
        d: 'дн',
        h: 'год',
        error: 'Не вдалося завантажити дані про відпустку. Спробуйте ще раз.',
        retry: 'Повторити'
    },
    update: {
        title: 'Доступне оновлення',
        whatsNew: 'Що нового',
        updateApp: 'Оновити додаток',
        installNewVersion: 'Встановити нову версію',
        later: 'Пізніше',
        downloadingBundle: 'Завантаження оновлення...',
        downloadingApk: 'Завантаження інсталятора...',
        downloadFailed: 'Завантаження не вдалося. Спробуйте ще раз.',
        apkInstallHint: 'Вам буде запропоновано встановити оновлення.',
        readyToRestart: 'Оновлення завантажено! Перезапустіть застосунок для застосування нової версії.',
        restartNow: 'Перезапустити'
    }
}
